/** Select value for the "Sin Analizar" analyst filter option (index 0 in dropdown). */
export const UNASSIGNED_ANALYST_FILTER_VALUE = '__unassigned__';
